export function isT<T>(item: T | undefined): item is T {
  return item !== undefined;
}
